import { useState, useEffect } from 'react';

const ClubsResortStatCard = ({ title, value }) => {
  const [displayValue, setDisplayValue] = useState('0');

useEffect(() => {
  // ✅ Normalize value safely
  const rawValue =
    value === null || value === undefined ? "" : String(value);

  // Extract prefix (like $), suffix (like %), and numeric value
  const prefix = rawValue.match(/^[^\d.,]+/)?.[0] || "";
  const suffix = rawValue.match(/[^\d.,]+$/)?.[0] || "";
  const numericString = rawValue.replace(/[^\d.,]/g, "");

  const numericValue = parseFloat(numericString.replace(/,/g, ""));

  if (isNaN(numericValue)) {
    setDisplayValue(rawValue || "-");
    return;
  }

  const hasDecimals = numericString.includes(".");
  const decimalPlaces = hasDecimals
    ? numericString.split(".")[1]?.length || 0
    : 0;

  const duration = 2000;
  const steps = 60;
  const stepDuration = duration / steps;
  const increment = numericValue / steps;

  let currentStep = 0;

  const timer = setInterval(() => {
    currentStep++;

    if (currentStep >= steps) {
      setDisplayValue(
        formatValue(numericValue, prefix, suffix, decimalPlaces)
      );
      clearInterval(timer);
    } else {
      const currentValue = increment * currentStep;
      setDisplayValue(
        formatValue(currentValue, prefix, suffix, decimalPlaces)
      );
    }
  }, stepDuration);

  return () => clearInterval(timer);
}, [value]);


  const formatValue = (num, prefix, suffix, decimalPlaces) => {
    let formatted = num;

    // Handle decimal places
    if (decimalPlaces > 0) {
      formatted = num.toFixed(decimalPlaces);
    } else {
      formatted = Math.floor(num);
    }

    // Add commas for thousands
    if (num >= 1000) {
      formatted = Number(formatted).toLocaleString('en-US', {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      });
    }

    return `${prefix}${formatted}${suffix}`;
  };

  return (
    <div className="bg-white rounded-xl p-4 main-shadow flex flex-col">
      <p className="font-normal text-textcolor text-base tracking-[0] leading-[normal] mb-2">
        {title}
      </p>
      <h2 className="font-semibold text-black text-[35px] tracking-[0]">
        {displayValue}
      </h2>
    </div>
  );
};

export default ClubsResortStatCard;
